// extracted by mini-css-extract-plugin
export var acitonButtons = "_33-0";
export var additionalIcon = "_33-f";
export var block = "_33-1";
export var blockContent = "_33-7";
export var blockDescription = "_33-8";
export var blockIcon = "_33-9";
export var blockTitle = "_33-6";
export var border = "_33-a";
export var center = "_33-l";
export var edge = "_33-b";
export var edgeLabel = "_33-c";
export var edgePath = "_33-d";
export var error = "_33-e";
export var flowchart = "_33-g";
export var flowchartContent = "_33-h";
export var highlighted = "_33-3";
export var hover = "_33-4";
export var icon = "_33-i";
export var left = "_33-m";
export var navButton = "_33-j";
export var navButtons = "_33-k";
export var right = "_33-n";
export var selected = "_33-2";
export var small = "_33-5";